import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";

export type RedeemInviteInput = {
  token: string;
  password?: string;
};

export type RedeemInviteResponse = {
  ok: true;
  magic_link_sent: boolean;
};

// POST /api/invites/redeem. The worker handles rate-limit, identity check,
// auth.users creation, and the SECURITY DEFINER finalize RPC. The SPA only
// needs the mutation surface.
export function useRedeemInvite() {
  return useMutation<RedeemInviteResponse, ApiClientError, RedeemInviteInput>({
    mutationFn: (input) =>
      apiFetch<RedeemInviteResponse>("/invites/redeem", {
        method: "POST",
        body: JSON.stringify(input),
      }),
  });
}
